import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class ExpSumNotExceededForEachStackGroupValidator extends BaseValidator {
    private expMaxPercent: number = Const.LEGACY_CONTROLLED_STACKING_EXP_MAX_PERCENT;
    protected runValidation(): void {
        // @ts-ignore
        const {legacyControlledHitterStacking} = this.dependencies;

        const firstGroupItems = legacyControlledHitterStacking.getFirstGroupItems();
        const firstGroupExpSum = this.calcExpSumForItems(firstGroupItems);

        if (firstGroupExpSum > this.expMaxPercent) {
            this.addError(this.getErrorMessage(1));
            return;
        }

        const secondGroupItems = legacyControlledHitterStacking.getSecondGroupItems();
        const secondGroupExpSum = this.calcExpSumForItems(secondGroupItems);

        if (secondGroupExpSum > this.expMaxPercent) {
            this.addError(this.getErrorMessage(2));
        }
    }

    private calcExpSumForItems(items): number {
        let expSum = 0;
        for (let item of items) {
            expSum += item.expMin;
        }

        return expSum;
    }

    private getErrorMessage(stackNumber: number): string {
        return `The total exposure in the hitter stack ${stackNumber} exceeds ${this.expMaxPercent}%, please decrease.`;
    }
}

export default ExpSumNotExceededForEachStackGroupValidator;
